import { Col, Form, FormProps, Row } from "@pankod/refine-antd";
import { IShootExecutionForm } from "components/forms/frm_shootexecution";
import { Dayjs } from "dayjs";
import { IScheduleWindow } from "interfaces";
import {
  getNextValidDateTime,
  isWithinSchedule,
  validateTemplateSchedule,
} from "utils/shootexecution";
import { DateTimeInput } from "./datetime-input";

interface NextShootCardProps {
  name: string;
  index: number;
  executionMinutes: number;
  formProps: FormProps<IShootExecutionForm>;
  schedule?: IScheduleWindow;
}

export interface INextShootSchedule {
  name: string;
  order: number;
  template_id: string;
  scheduled_datetime: Dayjs;
}

export function NextShootCard({
  name,
  index,
  executionMinutes,
  formProps,
  schedule,
}: NextShootCardProps) {
  const handleDateTimeChange = (value?: Dayjs) => {
    if (!schedule) return;

    const templates: INextShootSchedule[] =
      formProps.form?.getFieldValue("templates_schedule") || [];

    const updatedTemplates = [...templates];

    if (value) {
      updatedTemplates[index].scheduled_datetime = value;

      for (let i = index + 1; i < updatedTemplates.length; i++) {
        const prevDateTime = updatedTemplates[i - 1].scheduled_datetime;
        updatedTemplates[i].scheduled_datetime = getNextValidDateTime(
          prevDateTime,
          executionMinutes,
          schedule
        );
      }
    } else {
      for (let i = index; i < updatedTemplates.length; i++) {
        updatedTemplates[i].scheduled_datetime = null as any;
      }
    }

    formProps.form?.setFieldsValue({
      templates_schedule: updatedTemplates,
    });
  };

  return (
    <Row gutter={[16, 16]} align="middle">
      <Col xs={24} md={4} style={{ marginTop: "1rem" }}>
        <h3>{name}</h3>
      </Col>

      <Col xs={24} md={20}>
        <Form.Item
          name={[index, "scheduled_datetime"]}
          rules={[
            {
              validator: async (_, value: Dayjs | null) => {
                if (!value) {
                  return Promise.reject(
                    "Selecione a data/hora para execução do disparo."
                  );
                }

                if (!isWithinSchedule(value, schedule)) {
                  return Promise.reject(
                    "A data/hora não está dentro do horário possível de execução."
                  );
                }

                return Promise.resolve();
              },
            },
            {
              validator: validateTemplateSchedule(
                index,
                executionMinutes,
                formProps.form
              ),
            },
          ]}
        >
          <DateTimeInput
            onChange={handleDateTimeChange}
            disabled={!executionMinutes}
          />
        </Form.Item>
      </Col>
    </Row>
  );
}
